
import React, { useState } from "react";
import Sidebar from "./MainSidebar"; 
import Profile from "./Profile"; 
import "../../styles/SettingsPage.css";

const SettingsPage = () => {
  const [activeSection, setActiveSection] = useState(null);

  return (
    <div className="settings-layout">
      <Sidebar /> 
      <main className="settings-content">
        {activeSection === "profile" ? <Profile /> : <h2>Select a setting</h2>}
      </main>
    </div>
  );
};

export default SettingsPage;
